import loadRecaptcha from "./load_recaptcha"
import recaptchaToken from "./recaptcha_token"
import { addEventListenerWithKey } from "shared/lib/utils.js"

const warmWhenIdle = warm => {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(warm)
  } else {
    setTimeout(warm, 0)
  }
}

export default function handleRecaptcha(sitekey) {
  const button = document.querySelector(".verify-with-recaptcha")
  if (!button) return

  const form = button.closest("form")

  // Load the script ahead of the click — never during it. Fetching at submit would add its latency
  // to every signup and give v3 no interaction window to score. Memoized, so these race harmlessly.
  // Keyed listeners rather than plain ones: these handlers close over per-call state, so a bfcache
  // restore that re-runs this setup would otherwise stack a second copy of each.
  const warm = () => loadRecaptcha(sitekey).catch(() => {})
  addEventListenerWithKey(form, "focusin", "recaptcha_warm_on_focus", warm)
  addEventListenerWithKey(window, "load", "recaptcha_warm_on_idle", () => warmWhenIdle(warm))

  const clickHandler = async e => {
    e.preventDefault()

    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }

    // form.submit() skips the submit event, so rails-ujs never applies data-disable-with itself.
    button.disabled = true
    if (button.dataset.disableWith) button.value = button.dataset.disableWith

    const token = await recaptchaToken(sitekey)

    // Submit either way. When reCAPTCHA is unreachable the server rejects a tokenless signup with a
    // real error, which beats swallowing the click and leaving the button silently dead.
    if (token) {
      const tokenInput = document.createElement("input")
      tokenInput.setAttribute("type", "hidden")
      tokenInput.setAttribute("name", "recaptcha_token")
      tokenInput.setAttribute("value", token)
      form.appendChild(tokenInput)
    }

    form.submit()
  }

  // Most important of the three: a duplicate click handler would mint two tokens, append two hidden
  // inputs and submit the form twice.
  addEventListenerWithKey(button, "click", "recaptcha_submit", clickHandler)
}
